import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Grid } from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Api from "../../services/api";
import SimpleAutoComplete from '../select/simple';
import RealSimpleAutoComplete from '../auto-complete/autocomplete-with-onclick';
import SimpleAutoCompleteSearch from '../auto-complete/autocomplete-search-api';
import SimpleDatePicker from '../date-pickers/inline';
import TagInputMui from '../tag-input/tag-input-mui';
import TagFilterAutocomplete from './TagFilterAutocomplete';
import TextFilterField from './TextFilterField';

const CalledFilters = (props) => {
    const {
        filtersCalled,
        drawerAnimationClass,
        // filter lists
        organizationsFilterList,
        loadingOrganizationFilter,
        categoriesFilterList,
        loadingCategoryFilter,
        statusFilterList,
        loadingStatusFilter,
        typeFilterList,
        loadingTypeFilter,
        requestUserFilterList,
        loadingRequestUserFilter,
        assignedUserFilterList,
        loadingAssignedUserFilter,
        locationFilterList,
        loadingLocationFilter,
        originFilterList,
        loadingOriginFilter,
        deptFilterList,
        loadingDeptFilter,
        techinicalTeamFilterList,
        loadingTechinicalTeamFilter,
        mailboxAddressFilterList,
        loadingMailboxAddressFilter,
        externalFormsFilterList,
        loadingExternalFormsFilter,
        registeredNumberFilterList,
        loadingRegisteredNumberFilter,
        customerNumberFilterList,
        loadingCustomerNumberFilter,
        webChatFilterList,
        loadingWebChatFilter,
        chatbotFilterList,
        loadingChatbotFilter,
        customOrganizationFilterFieldsList,
        // handlers
        changeInputValuesPerFilterTags,
        changeValuesPerFilter,
        getFilterOrganizations,
        getFilterCategoriesByOrganization,
        getFilterStatus,
        getFilterType,
        getFilterAssignedUser,
        getFilterLocationByOrganization,
        getFilterClassification,
        getFilterOrigin,
        getFilterDeptByOrganization,
        getFilterTechinicalTeam,
        getFilterMailboxAddress,
        getFilterExternalForms,
        getFilterRegisteredNumber,
        getFilterWebChat,
        getFilterChatbot,
        submitNewFilter,
        cleanNewFilter,
        // role flags
        isClient,
        // styles
        classes,
    } = props;

    const intl = useIntl();

    const cpfMask = (value) => value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');

    return (
        <Grid xs={3} className={`filter-drawer ${drawerAnimationClass}`} style={{maxHeight: '1350px', overflowY: 'auto', paddingTop: '10px', paddingLeft: '10px'}}>
            <Card className="background-title-search">
                <CardContent>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <TagInputMui
                            label="Id do Chamado"
                            placeholder="Digite para inserir"
                            helperText="Digite aqui os números dos chamados"
                            maxTags={10}
                            initialTags={[]}
                            allowDuplicates={false}
                            allowCaseSensitive={false}
                            onChange={(value) => {changeInputValuesPerFilterTags("calledId", value)}}
                            value={filtersCalled['calledId']}
                            onlyNumbers={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <TextFilterField
                            label="Título do Chamado"
                            name="calledTitle"
                            value={filtersCalled['calledTitle'] || ''}
                            onBlurChange={(v) => changeValuesPerFilter('calledTitle', v)}
                            autoComplete="fname"
                            inputProps={{ maxLength: 255 }}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "organization" })}
                            options={organizationsFilterList}
                            stateName="organizationId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterOrganizations}
                            loading={loadingOrganizationFilter}
                            selected={filtersCalled['organizationId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "category" })}
                            options={categoriesFilterList}
                            stateName="categoryId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterCategoriesByOrganization}
                            loading={loadingCategoryFilter}
                            selected={filtersCalled['categoryId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "status" })}
                            options={statusFilterList}
                            stateName="statusId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterStatus}
                            loading={loadingStatusFilter}
                            selected={filtersCalled['statusId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "type" })}
                            options={typeFilterList}
                            stateName="typeId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterType}
                            loading={loadingTypeFilter}
                            selected={filtersCalled['typeId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <SimpleAutoCompleteSearch
                            style={{background: 'white', fullWidth: true}}
                            label={ intl.formatMessage({ id: "requestuser" })+" (min 4 caracteres)"}
                            options={requestUserFilterList}
                            stateName="requestuserId"
                            changeSelect={changeValuesPerFilter}
                            selected={filtersCalled['requestuserId']}
                            loading={loadingRequestUserFilter}
                            minDigits={4}
                            urlapi={Api.apiurlbase()+'api/users/search/clientuser'}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "assigned" })}
                            options={assignedUserFilterList}
                            stateName="assigneduserId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterAssignedUser}
                            loading={loadingAssignedUserFilter}
                            selected={filtersCalled['assigneduserId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <SimpleDatePicker
                            label={intl.formatMessage({ id: "open.date" })}
                            stateName="openDate"
                            changeDate={changeValuesPerFilter}
                            currentDate={null}
                            value={filtersCalled['openDate']}
                            style={{background: 'white'}}
                            fullWidth={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "location" })}
                            options={locationFilterList}
                            stateName="locationId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterLocationByOrganization}
                            loading={loadingLocationFilter}
                            selected={filtersCalled['locationId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{margin: '6px', background: 'white'}}>
                        <SimpleAutoComplete
                            label={intl.formatMessage({id:"classification"})}
                            options={getFilterClassification()}
                            stateName="classification"
                            changeSelect={changeValuesPerFilter}
                            selected={filtersCalled['classification']}
                        />
                    </Grid>
                    <Grid xs={12} style={{padding: '6px'}}>
                        <RealSimpleAutoComplete
                            style={{background: 'white', fullWidth: true}}
                            label={intl.formatMessage({ id: "origin.call" })}
                            options={originFilterList}
                            stateName="originId"
                            changeSelect={changeValuesPerFilter}
                            onFocus={getFilterOrigin}
                            loading={loadingOriginFilter}
                            selected={filtersCalled['originId']}
                            multiple={true}
                        />
                    </Grid>
                    <Grid xs={12} style={{margin: '6px', background: 'white'}}>
                        <SimpleAutoComplete
                            label={intl.formatMessage({id:"called.list.calls.with.geolocalization"})}
                            options={[{id: 'true', name: 'Sim'}, {id: 'false', name: 'Não'}]}
                            stateName="geolocalization"
                            changeSelect={changeValuesPerFilter}
                            selected={filtersCalled['geolocalization']}
                        />
                    </Grid>
                    {!isClient && (
                        <>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <TextFilterField
                                    label="E-mail do solicitante"
                                    name="requestUserEmail"
                                    type="email"
                                    autoComplete="email"
                                    value={filtersCalled['requestUserEmail'] || ''}
                                    onBlurChange={(v) => changeValuesPerFilter('requestUserEmail', v)}
                                    inputProps={{ style: { textTransform: 'lowercase' } }}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <TextFilterField
                                    label={intl.formatMessage({ id: "request.user.document" })}
                                    name="requestuserdocument"
                                    value={filtersCalled['requestuserdocument'] || ''}
                                    onBlurChange={(v) => changeValuesPerFilter('requestuserdocument', v)}
                                    //transform={cpfMask}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label={intl.formatMessage({ id: "departament" })}
                                    options={deptFilterList}
                                    stateName="deptId"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterDeptByOrganization}
                                    loading={loadingDeptFilter}
                                    selected={filtersCalled['deptId']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{margin: '6px', background: 'white'}}>
                                <SimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label={intl.formatMessage({id:"is.called.expired"})}
                                    options={[{id: 'sim', name: 'Sim'}, {id: 'nao', name: 'Não'}]}
                                    stateName="expiredcall"
                                    changeSelect={changeValuesPerFilter}
                                    selected={filtersCalled['expiredcall']}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label={intl.formatMessage({id:"attendance.team"})}
                                    options={techinicalTeamFilterList}
                                    stateName="techinicalteamId"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterTechinicalTeam}
                                    loading={loadingTechinicalTeamFilter}
                                    selected={filtersCalled['techinicalteamId']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label={intl.formatMessage({id:"mail.box.config"})}
                                    options={mailboxAddressFilterList}
                                    stateName="mailboxaddress"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterMailboxAddress}
                                    loading={loadingMailboxAddressFilter}
                                    selected={filtersCalled['mailboxaddress']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label="Formulários externos"
                                    options={externalFormsFilterList}
                                    stateName="externalFormsId"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterExternalForms}
                                    loading={loadingExternalFormsFilter}
                                    selected={filtersCalled['externalFormsId']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label={intl.formatMessage({id:"registered.number"})}
                                    options={registeredNumberFilterList}
                                    stateName="registerednumber"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterRegisteredNumber}
                                    loading={loadingRegisteredNumberFilter}
                                    selected={filtersCalled['registerednumber']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <SimpleAutoCompleteSearch
                                    style={{background: 'white', fullWidth: true}}
                                    label={ intl.formatMessage({ id: "customer.number" })+" (min 4 caracteres)"}
                                    options={customerNumberFilterList}
                                    stateName="customernumber"
                                    changeSelect={changeValuesPerFilter}
                                    selected={filtersCalled['customernumber']}
                                    loading={loadingCustomerNumberFilter}
                                    minDigits={4}
                                    urlapi={Api.apiurlbase()+'api/users/search/clientphone'}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <TagFilterAutocomplete
                                    value={filtersCalled['tagIds']}
                                    onChange={(newValue) => changeValuesPerFilter('tagIds', newValue)}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label="Webchat"
                                    options={webChatFilterList}
                                    stateName="webchat"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterWebChat}
                                    loading={loadingWebChatFilter}
                                    selected={filtersCalled['webchat']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <RealSimpleAutoComplete
                                    style={{background: 'white', fullWidth: true}}
                                    label="Chatbot"
                                    options={chatbotFilterList}
                                    stateName="chatbot"
                                    changeSelect={changeValuesPerFilter}
                                    onFocus={getFilterChatbot}
                                    loading={loadingChatbotFilter}
                                    selected={filtersCalled['chatbot']}
                                    multiple={true}
                                />
                            </Grid>
                            <Grid xs={12} style={{padding: '6px'}}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography variant="h5" component="h5">
                                            {intl.formatMessage({ id: "organization.custom.fields" })}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <>
                                            {customOrganizationFilterFieldsList.length > 0 ? (
                                                customOrganizationFilterFieldsList
                                            ) : (
                                                <Typography variant="h5" component="h5">
                                                    Nenhum campo personalizado encontrado
                                                </Typography>
                                            )}
                                        </>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </>
                    )}

                </CardContent>
            </Card>

            <Grid container direction="row-reverse">
                <Grid style={{margin: 10}} xs={5} item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                        className={classes.button}
                        onClick={() => submitNewFilter(false)}
                    >
                        Aplicar
                    </Button>
                </Grid>
                <Grid style={{margin: 10}} xs={5} item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                        className={classes.button}
                        onClick={cleanNewFilter}
                    >
                        Limpar
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CalledFilters;
